module.exports = __webpack_public_path__ + "img/cooperation24.50204997.png";